import { get, post, postJson, put, } from '../axios2'

// 保存赠品定制活动
export const saveActivity  = p => postJson(`/freeGift/saveActivity`,p);

// 查询赠品定制活动详情
export const detail  = id => get(`/freeGift/detail/${id}`,);

// 进行中赠品定制活动修改接口
export const updateActivity  = p => postJson(`/freeGift/updateActivity`,p);

// 解锁记录
export const checkOrderRecord  = p => get(`/freeGift/checkOrderRecord`,p);

// 解锁记录导出
export const exportCheckOrderRecord  = p => get(`/freeGift/checkOrderRecord/export`,p);

// 赠品列表(手动解锁弹窗显示需要)
export const getPrizeList  = id => get(`/freeGift/prizeList/${id}`,);

// 查询中奖记录分页接口
export const getWinRecord  = p => get(`/freeGift/winRecord/page`,p);

// 根据查询条件导出中奖记录
export const exportWinRecord  = p => postJson(`/freeGift/winRecord/export`,p);

// 手动解锁
export const check  = p => postJson(`/freeGift/check`,p);

// 批量解密
export const decryptBatch  = p => postJson(`/public/decryptBatch`,p);

// b端计算罐数接口
export const freeGiftCompute  = p => postJson(`/freeGift/compute`,p);

// 取消处理(单个)
export const cancelProcess  = id => get(`/freeGift/cancelProcess/${id}`);

// 更新中奖记录奖品名称
export const updatePhysicalPrizeName  = p => postJson('/freeGift/updatePrizeName', p);

// 标记失效接口
export const freeGiftMarkLoseEfficacy  = recordId => get(`/freeGift/markLoseEfficacy/${recordId}`, {});